module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "storelinks"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("thank_you")))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0142273d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StoreLinks.vue
// module id = 405
// module chunks = 2